import {X} from 'lucide-react';
import {cn} from '../lib/cn';

export interface UploadedFilesListProps {
  files: File[];
  onRemoveFile: (fileName: string) => void;
  className?: string;
}

export function UploadedFilesList({
  files,
  onRemoveFile,
  className,
}: UploadedFilesListProps) {
  if (!files.length) {
    return null;
  }

  return (
    <div className={cn('flex flex-wrap gap-2.5', className)}>
      {files.map((file, index) => (
        <div
          key={`${file.name}-${index}`}
          className="flex cursor-default items-center gap-2 rounded border border-[var(--chekin-neutral-400)] bg-[var(--chekin-neutral-75)] py-1.5 pl-3 pr-1.5"
        >
          <span className="text-nowrap text-sm font-medium leading-5 text-[var(--chekin-blue-900)]">
            {file.name}
          </span>
          <button
            type="button"
            onClick={() => onRemoveFile(file.name)}
            className="flex h-[18px] w-[18px] shrink-0 cursor-pointer items-center justify-center rounded bg-[var(--chekin-neutral-600)] transition-all hover:shadow-md active:opacity-95"
            aria-label={`Remove ${file.name}`}
          >
            <X className="h-3.5 w-3.5 text-white" strokeWidth={3} />
          </button>
        </div>
      ))}
    </div>
  );
}
